import {
    DOMUtils,
    HttpRequest
} from "./Utils";
import {
    setButtonEvent
} from "./dialog.js"
import {
    loadDatagroups,
    benutzerVerwaltung,
    appendUserRegister,
    createRoomDlg,
    showUserVerwaltung,
    createGroup
} from "./liste.js"
import {
    loginBtn
} from "./home.js"

window.$DOM = DOMUtils;

function navButtonsHideAll() {
    $DOM('a[data-isnav]').addClass("hidden");
}

function initNavButtons() {
    setButtonEvent("btn-footer", () => {
        e.preventDefault();
        if (window.location.hash !== "liste") {
            window.location = "#liste";
        }
    });

    setButtonEvent("navburger", navBarToggle);

    setButtonEvent("btn-create-group", createGroup);
    setButtonEvent("btn-userverwaltung", showUserVerwaltung);
    setButtonEvent("btn-create-room", createRoomDlg, null);
    setButtonEvent("btn-create-user", appendUserRegister);
    setButtonEvent("btn-user-name", benutzerVerwaltung);

    setButtonEvent("btn-login", loginBtn);
    setButtonEvent("header-home", homeButtonHandle);

}

function homeButtonHandle() {
    if (location.hash == "liste") {
        e.preventDefault();
        loadDatagroups();
    }
}

function navBarToggle() {
    // var x = document.getElementById("topNavbar");
    const x = $DOM("#topNavbar");
    if (x.hasClass("responsive")) {
        x.removeClass("responsive");
    } else {
        x.addClass("responsive");
    }
}


export {
    initNavButtons,
    navButtonsHideAll
}